import React, { createContext, useContext, useMemo } from 'react'
import { useLocalStorage } from "./useLocalStorage";
import { useNavigate } from 'react-router-dom';
const AuthContext = createContext();
    
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage("user", null);
  const navigate = useNavigate()

  const logout = () => {
    setUser(null)
    navigate("/")
  }

  const value = useMemo(
    () => ({
      user,
      setUser,
      logout,
    }),
    [user, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
};

export const useAuth = () => {
  return useContext(AuthContext)
};
